import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { defaultEntregaObraClienteReportGeralForm, EntregaObraClienteReportGeralForm, EntregaObraClienteReportGeralSchema } from "../../../schemas/entrega_obra_cliente_lista/entregaObraClienteReportGeral";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { useEffect } from "react";


type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedIdEntregaObra?: number,
    ddlChecklist: DropDown[],
    ddlCliente: DropDown[],
    ddlUnidade: DropDown[],
    ddlLocalVistoria: DropDown[],

    onClose: () => void,
    onSubmit: (form: EntregaObraClienteReportGeralForm) => void,
}

export const EntregaObraClienteReportGeralModal = ({
    open,
    saving,
    loading,
    ddlChecklist,
    ddlCliente,
    ddlUnidade,
    ddlLocalVistoria,
    selectedIdEntregaObra,
    onClose,
    onSubmit,
}: props) => {


    useEffect(() => {
        if (!open)
            return;
        hookFormCadastro.setValue('idEntregaObra', selectedIdEntregaObra);

    }, [selectedIdEntregaObra, open]);



    const hookFormCadastro = useForm<EntregaObraClienteReportGeralForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultEntregaObraClienteReportGeralForm,
        resolver: zodResolver(EntregaObraClienteReportGeralSchema),
    });


    const handleClose = () => {
        hookFormCadastro.reset();
        onClose();
    };

    const handleSubmit = (form: EntregaObraClienteReportGeralForm) => {
        hookFormCadastro.reset();
        onSubmit(form);
    };

    const statusOptions: DropDown[] = [
        { id: 0, title: 'Em Aberto' },
        { id: 1, title: 'Entregue' },
    ];

    const vistoriaOptions: DropDown[] = [
        { id: 1, title: 'Cliente' },
        { id: 0, title: 'Construtora' },
    ];


    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Monitoramento Checklist de Entrega de Obra"
            onClose={handleClose}
            confirmButtonLabel="Gerar Relatório"
            onSubmit={hookFormCadastro.handleSubmit(handleSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <div className=" w-full flex items-start justify-between">
                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="idsCliente"
                                label="Cliente"
                                required={false}
                                options={ddlCliente}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>

                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="idsUnidade"
                                label="Unidade"
                                required={false}
                                options={ddlUnidade}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>



                    </div>

                    <div className=" w-full flex items-start justify-between">
                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="idsChecklist"
                                label="Checklist"
                                required={false}
                                options={ddlChecklist}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>

                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="status"
                                label="Status"
                                required={false}
                                options={statusOptions}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>
                    </div>

                    <div className=" w-full flex items-start justify-between">

                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="idsLocalVistoria"
                                label="Local de Vistoria"
                                required={false}
                                options={ddlLocalVistoria}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>

                        <div className="w-[45%]">
                            <DefaultFormMultiAutocomplete
                                name="vistoria"
                                label="Vistoria"
                                required={false}
                                options={vistoriaOptions}
                                getOptionLabel={x => x.title}
                                getOptionKey={x => x.id}
                                reactHookForm={hookFormCadastro} />
                        </div>

                    </div>

                    <div className="flex flex-row gap-4 w-full justify-between">
                        <FormDatePickerInput
                            name='dataDe'
                            label='Data De'
                            required={false}
                            readOnly={false}
                            reactHookForm={hookFormCadastro}
                        />

                        <FormDatePickerInput
                            name='dataAte'
                            label='Data Até'
                            required={false}
                            readOnly={false}
                            reactHookForm={hookFormCadastro}
                        />
                    </div>
                </>
            </FormContainer>

        </BaseFormControlledModal>
    );
}